import React from "react";
import { useTranslation } from "react-i18next";
import { TaskStatus } from "../../types/tasks";
import { TASK_STATUS_COLORS } from "../../constants/taskConstants";

interface Props {
  status: TaskStatus;
}

export const TaskStatusBadge: React.FC<Props> = ({ status }) => {
  const { t } = useTranslation("tasks");
  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${TASK_STATUS_COLORS[status]}`}
    >
      {t(`form.statusOptions.${status}`)}
    </span>
  );
};
